module.exports = __webpack_public_path__ + "06_bob_black.4939790b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_bob_black.png
// module id = njnt
// module chunks = 0